<template>
  <div class="itemBox">
    <img :src="itemInfoList[hoverIndex-1].img" alt />
    <div class="hoverShow">
      <img :src="itemInfoList[hoverIndex-1].icon" alt="">
      <div class="title">{{itemInfoList[hoverIndex-1].title}}</div>
      <div class="text">{{itemInfoList[hoverIndex-1].text}}</div>
    </div>
  </div>
</template>
<script>
import img1 from "@/assets/img/home/hy1.png";
import img2 from "@/assets/img/home/hy2.png";
import img3 from "@/assets/img/home/hy3.png";
import icon1 from "@/assets/img/home/hyIcon3.png";
import icon2 from "@/assets/img/home/hyIcon3.png";
import icon3 from "@/assets/img/home/hyIcon3.png";
export default {
  name: "hover",
  props: ["hoverIndex"],
  data() {
    return {
      showFlag: false,
      itemInfoList: [
        { img: img1, title:'行业领先',text: "打造以中国传统文化和现代人文属性相融合的新型文化创意产业新格局",icon:icon1},
        { img: img2, title:'口碑信任', text: "十年专业艺术品收藏机构 200万用户口碑信任",icon:icon2},
        { img: img3, title:'行家云集', text: "邀请多位非物质文化传承人以及知名艺术大师加盟",icon:icon3}
      ]
    };
  },
  mounted() {
  },
  methods: {
    showQRCode() {
      this.showFlag = true;
    },
    hideQRCode() {
      this.showFlag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.itemBox {
  width: 400px;
  height: 340px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .hoverShow:hover {
    background: rgba(213,38,43,0.8);
  }
  .hoverShow {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: #fff;
    width: 100%;
    height: 100%;
    text-align: center;
    background: rgba(0,0,0,0.6);
    img {
      width: 64px;
      height: 64px;
      margin: 72px auto 0;
    }
    .title{
      font-size: 20px;
      margin-top: 36px;
    }
    .text {
      width: 238px;
      margin: 28px auto 0;
      font-size: 14px;
      line-height: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/components/hoverItem4.vue